import React from 'react';
import './style.css';

const style = { width: '100%', display: 'block'};
const ProgressBar = (props) => (
  <div
    style={{...style, ...props.style}}
    className="mdl-progress mdl-js-progress mdl-progress__indeterminate"
  />
);

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/ProgressBar/index.js